// src/components/auth/AdminSetup.js
import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where, updateDoc, doc, limit } from 'firebase/firestore';
import { db } from '../../firebase';

function AdminSetup() {
  const [emails, setEmails] = useState([]);
  const [selectedEmail, setSelectedEmail] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        // Check if there's already an admin
        const adminQuery = query(
          collection(db, 'users'),
          where('role', '==', 'admin'),
          limit(1)
        );
        const adminSnapshot = await getDocs(adminQuery);
        
        if (!adminSnapshot.empty) {
          setError('An admin already exists in the system.');
          setLoading(false);
          return;
        }

        // Get all users who are not admins yet
        const usersQuery = query(collection(db, 'users'));
        const snapshot = await getDocs(usersQuery);
        
        const userEmails = [];
        snapshot.forEach(doc => {
          userEmails.push({
            id: doc.id,
            email: doc.data().email
          });
        });
        
        setEmails(userEmails);
        setLoading(false);
      } catch (err) {
        setError('Failed to load users: ' + err.message);
        setLoading(false);
      }
    };

    fetchUsers();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedEmail) {
      setError('Please select a user to make admin');
      return;
    }

    try {
      setLoading(true);
      // Find the user by email
      const selectedUser = emails.find(user => user.email === selectedEmail);
      
      if (selectedUser) {
        // Update the user's role to admin
        await updateDoc(doc(db, 'users', selectedUser.id), {
          role: 'admin'
        });
        
        setSuccess(true);
        setError(null);
      } else {
        setError('Selected user not found');
      }
    } catch (err) {
      setError('Failed to update user: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div>Loading users...</div>;
  }

  if (success) {
    return (
      <div className="admin-setup success">
        <h3>Admin Setup Complete</h3>
        <p>User {selectedEmail} has been assigned the admin role.</p>
        <p>You can now log in as this user to access admin functionality.</p>
      </div>
    );
  }

  return (
    <div className="admin-setup">
      <h2>First-Time Admin Setup</h2>
      
      {error && <div className="error-message">{error}</div>}
      
      {emails.length === 0 ? (
        <p>No users found. Please register at least one user first.</p>
      ) : (
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="adminEmail">Select a user to make admin:</label>
            <select
              id="adminEmail"
              value={selectedEmail}
              onChange={(e) => setSelectedEmail(e.target.value)}
              required
            >
              <option value="">-- Select User --</option>
              {emails.map(user => (
                <option key={user.id} value={user.email}>
                  {user.email}
                </option>
              ))}
            </select>
          </div>
          
          <button type="submit" disabled={loading}>
            {loading ? 'Processing...' : 'Make Admin'}
          </button>
        </form>
      )}
    </div>
  );
}

export default AdminSetup;